// extracted by mini-css-extract-plugin
export var activeLink = "Header-module--activeLink--26ca1";
export var desktopNavItem = "Header-module--desktopNavItem--b517f";
export var getStarted = "Header-module--getStarted--34d29";
export var header = "Header-module--header--59cbe";
export var logo = "Header-module--logo--bd77e";
export var nav = "Header-module--nav--2d483";
export var navBurger = "Header-module--navBurger--57e59";
export var navigation = "Header-module--navigation--fe62f";